export enum PerpetratorIdentity {
	KNOWN = 0,
	UNKNOWN = 1,
}
